export default __webpack_public_path__ + "static/media/civil-rights-march.456d1988.png";